<template>
  <b-modal
    id="file-manager-modal"
    ref="fileManagerModal"
    title="File Manager"
    size="lg"
    hide-footer
  >
    <div class="file-manager">
      <div class="file-list-container">
        <h5>Existing Files</h5>
        <b-list-group>
          <b-list-group-item
            v-for="file in files"
            :key="file.id"
            @click="selectFile(file)"
            :active="selectedFile && selectedFile.id === file.id"
            class="d-flex justify-content-between align-items-center"
          >
            {{ file.name }}
            <b-button variant="primary" size="sm" @click.stop="selectFile(file)">Select</b-button>
          </b-list-group-item>
        </b-list-group>
      </div>
      <hr>
      <div class="upload-container">
        <h5>Upload New File</h5>
        <FileUpload @file-uploaded="handleFileUploaded" />
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-end">
        <b-button variant="secondary" @click="closeModal">Cancel</b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton, BListGroup, BListGroupItem } from 'bootstrap-vue'
import FileUpload from './FileUpload.vue'

export default {
  name: 'FileManager',
  components: {
    BModal,
    BButton,
    BListGroup,
    BListGroupItem,
    FileUpload,
  },
  data() {
    return {
      files: [
        // Dummy data, will be replaced by API call
        { id: 1, name: 'document1.pdf', url: '/documents/document1.pdf' },
        { id: 2, name: 'image.png', url: '/documents/image.png' },
      ],
      selectedFile: null,
    }
  },
  methods: {
    show() {
      this.$refs.fileManagerModal.show()
    },
    closeModal() {
      this.$refs.fileManagerModal.hide()
    },
    selectFile(file) {
      this.selectedFile = file
      this.$emit('file-selected', file.url)
      this.closeModal()
    },
    handleFileUploaded(uploadResult) {
      // Add the new file to the list
      const newFile = {
        id: new Date().getTime(), // temporary id
        name: uploadResult.file.name,
        url: uploadResult.response.fileUrl, // assuming server returns url in fileUrl
      };
      this.files.push(newFile);
    },
  },
}
</script>

<style scoped>
.file-manager {
  display: flex;
  flex-direction: column;
}
.file-list-container {
  margin-bottom: 1rem;
}
</style>
